if (!customElements.get('flash-sale-countdown')) {
  class FlashSaleCountdown extends HTMLElement {
    connectedCallback() {
      this.daysElement = this.querySelector('[data-days]');
      this.hoursElement = this.querySelector('[data-hours]');
      this.minutesElement = this.querySelector('[data-minutes]');
      this.secondsElement = this.querySelector('[data-seconds]');
      this.anchorTime = Date.parse(this.dataset.endDate || '');
      this.cycleMilliseconds = (Number(this.dataset.cycleDays) || 7) * 24 * 60 * 60 * 1000;

      this.update();

      if (!Number.isNaN(this.anchorTime)) {
        this.interval = window.setInterval(() => this.update(), 1000);
      }
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }

    update() {
      const now = Date.now();
      let remaining = 0;

      if (!Number.isNaN(this.anchorTime) && this.cycleMilliseconds > 0) {
        remaining = (this.anchorTime - now) % this.cycleMilliseconds;
        if (remaining <= 0) remaining += this.cycleMilliseconds;
      }

      const totalSeconds = Math.ceil(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.daysElement.textContent = String(days).padStart(2, '0');
      this.hoursElement.textContent = String(hours).padStart(2, '0');
      this.minutesElement.textContent = String(minutes).padStart(2, '0');
      this.secondsElement.textContent = String(seconds).padStart(2, '0');

      this.setAttribute(
        'aria-label',
        `${days} days, ${hours} hours, ${minutes} minutes, ${seconds} seconds remaining`,
      );
    }
  }

  customElements.define('flash-sale-countdown', FlashSaleCountdown);
}
